var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.data.categories !== undefined && _vm.data.series !== undefined)?_c('apexchart',{attrs:{"height":"250px","width":_vm.width ? _vm.width : '100%',"type":_vm.type ? _vm.type: 'line',"options":{
            chart: {
                animations: {
                    enabled: false
                }
            },
            xaxis: {
                type: 'datetime',
                labels: {
                    show: !_vm.historic ? true : false,
                    datetimeUTC: false,
                }
            },
            plotOptions: {
                bar: {
                    horizontal: false,
                    columnWidth: '45%', //bar thickness
                },
            },
            tooltip: {
                x: {
                    show: true,
                    format: !_vm.historic ? 'HH:mm' : 'dd',
                },
            },
            dataLabels: {
                enabled: false
            },
            stroke: {
                curve: !_vm.historic ? 'smooth' : undefined,
            }
        },"series":!_vm.historic 
            ? _vm.data.series.map( function (s) { return { name: ("Line " + (parseInt(s.line) + 1) + " - " + (s.prop === 'watts' ? 'kilowatts' : s.prop)), data: s.data } })
            : _vm.data.series.map( function (s) { return ({ name: s.prop, data: s.data }); } )}}):_c('p',[_vm._v("Loading ...")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }